import { call, put, takeEvery } from 'redux-saga/effects';
import { categoryService } from '@iso/services';
import {
  GET_CATEGORIES_MULTI,
  GET_CATEGORIES_MULTI_SUCCESS,
  GET_CATEGORIES_MULTI_ERROR,
} from './actions';

function* getCategoriesMultiSaga(action) {
  try {
    // Call API
    const response = yield call(categoryService.getCategoriesMulti);
    // Legacy style: use only rows array like categoryList (backend returns 'rows')
    const rows = response?.data?.rows ?? response?.rows ?? [];
    yield put({ 
      type: GET_CATEGORIES_MULTI_SUCCESS, 
      payload: rows 
    });
    
  } catch (error) {
    // Dispatch error action
    yield put({ 
      type: GET_CATEGORIES_MULTI_ERROR, 
      payload: error 
    });
  }
}

export default function* categorySaga() {
  yield takeEvery(GET_CATEGORIES_MULTI, getCategoriesMultiSaga);
}
